module.exports = StaticSnapFrontendClasses;